
            const data = {"name":"archive","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" d=\"M28 10.668v17.333H4V10.668M30.667 4H1.333v6.667h29.334V4ZM13.333 16h5.334\" _stroke=\"#7D92A7\" stroke-width=\"2.667\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#7D92A7"}],"stopColors":[]}}
        
                    module.exports = data
                    